export default __webpack_public_path__ + "static/media/Roboto-Medium.b14ca2d2.woff";